import { Help } from '../api';

export const fetchHelp = () => (dispatch, getStore) => {
  dispatch(setHelpLoading());

  Help.getWhere()
    .then((response) => {
      if (response.result !== 'success') {
        throw new Error(response.error);
      }

      response.data.map((help) => {
        // Add the help to the store
        dispatch(setHelp(help));
      });
      dispatch(setHelpFile(response.file));
    })

    .catch((e) => {
      console.log(e);

      dispatch(setHelpError());
    });
};

export const setHelp = (help) => ({
  type: 'SET_HELP',
  help,
});

export const setHelpFile = (file) => ({
  type: 'SET_HELP_FILE',
  file,
});

export const setHelpContent = (item) => ({
  type: 'SET_HELP_OPEN',
  item,
});

export const resetHelpContent = () => ({
  type: 'SET_HELP_RESET',
});

export const setHelpLoading = (programs) => ({
  type: 'SET_PROGRAMS_LOADING',
});

export const setHelpError = (message = 'Sorry, an error occurred') => ({
  type: 'SET_PROGRAMS_ERROR',
  message,
});
